export const ProjectStatus = {
  PROJECT_STATUS_DELETED: 'deleted',
  PROJECT_STATUS_ARCHIVED: 'archived'
};
